<div class="row_1">
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>

        <div style="display: flex; justify-content: space-between; padding-left: 16px; padding-right: 16px; padding-top: 15px;">
            <div style="display: flex; justify-content: flex-start; align-items: center; gap:20px; flex-wrap:nowrap;">
                <button class="primarybutton" (click)="goBack()">BACK</button>
            </div>
            <div style="display: flex; justify-content: flex-end; align-items: center; gap:20px; flex-wrap:nowrap;">
                <button class="primarybutton" (click)="RefreshData()">REFRESH</button>

                <label class="catlabel">Route Date : {{routeDate}} </label>
                <label class="catlabel">Route : {{route}} </label>
                <label class="catlabel">Plant : {{plant}}</label>
                <label class="catlabel">Supplier : {{supplier}} </label>
                <label class="catlabel">Dock : {{dock}} </label>

                <button class="primarybutton" (click)="onBtExport()">EXPORT</button>
            </div>
        </div>
        
        <div class="grid-agg" style="margin-top: 0%;">
            <label class="gridcaption">Blowout Investigation - By PartNumber
            </label>
            <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
                'width':'100%'}" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
                [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="displayRowData"
                [gridOptions]="gridOptions" [context]="context" [pagination]="true" [paginationPageSize]="10"
                [icons]="icons">
            </ag-grid-angular>
            <div class="custom-pagination" *ngIf="totalRecords > 0">
                <div class="left">
                    <span class="records-per-page">
                        <span>Records/Page : </span>
                        <select [(ngModel)]="rpPage" (change)="rppChanged($event)">
                            <option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
                        </select>
                    </span>
                </div>
                <div class="right">
                    <span class="viewing-records">
                        <span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span
                            class="w-600">{{totalRecords}}</span>
                        <button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i
                                class="fa-solid fa-backward-fast"
                                [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                        <button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i
                                class="fa-solid fa-backward-step"
                                [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                        <span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
                        <button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i
                                class="fa-solid fa-forward-step"
                                [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                        <button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i
                                class="fa-solid fa-forward-fast"
                                [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    </span>
                </div>
            </div>
        </div>
        <!-- <div>
            <button class="secondarybutton" style="margin:0 1% 1% 4%" (click)="goBack();">BACK</button>
        </div> -->
    </div>
</div>